
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CurrentUser } from '../../models/user/current-user.model';

@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    private permissions: Set<string> = new Set<string>();
    private permissionsChangedSubject = new BehaviorSubject<void>(undefined);

    permissionsChanged$ = this.permissionsChangedSubject.asObservable();

    constructor() {
        this.loadPermissionsFromLocalStorage();
    }

    loadPermissionsFromLocalStorage() {
        this.permissions.clear();
        const storedUser = localStorage.getItem('currentUser');
        if (storedUser) {
            try {
                const user: CurrentUser = JSON.parse(storedUser);
                if (user.role && Array.isArray(user.role.roleClaims)) {

                    user.role.roleClaims.forEach(item => {
                        if (item.claim && item.claim.name) {
                            this.permissions.add(item.claim.name);
                            console.log("claims", item.claim.name);
                        }
                    });

                }
            } catch (e) {
                console.error('Yetkiler parse edilirken hata:', e);
            }
        }
    }

    hasPermission(permission: string): boolean {
        return this.permissions.has(permission);
    }

    hasAnyPermission(permissions: string[]): boolean {
        if (!permissions || permissions.length === 0) return true;
        return permissions.some(p => this.permissions.has(p));
    }

    reload() {
        this.loadPermissionsFromLocalStorage();
        this.permissionsChangedSubject.next();
    }
}